import requestService from './requestService';

const endpoints = {
  aiSessions: '/chatroom/ai-sessions',
  transcriptEmail: '/chatroom/transcriptEmail',
};

const AI_SESSION_HISTORY_DAYS = 30;
const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const filterRecentAiSessions = (sessions, now = Date.now()) => {
  const cutoff = now - AI_SESSION_HISTORY_DAYS * DAY_IN_MILLISECONDS;
  return (sessions || []).filter(session => {
    const timestamp = Date.parse(session?.time);
    return Number.isFinite(timestamp) && timestamp >= cutoff && timestamp <= now;
  });
};

// Lists the current customer's ended AI interpretation sessions (TUL-5142).
export const getAiSessions = async() => {
  try {
    const data = await requestService.get(endpoints.aiSessions, '', { apiType: 'platform-v2' });
    return {
      sessions: filterRecentAiSessions(data?.sessions),
      transcriptionSummaryMode: data?.transcriptionSummaryMode || null,
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
};

// Asks the platform to email the transcript (+ optionally the summary) magic links for a chatroom (TUL-4919).
// When `email` is given it overrides the default (the starter's account email).
// `includeSummary` is opt-in and sent in the request body; the platform defaults to no summary.
// `subject` is the optional user-defined text the platform puts into the email subject in place
// of the invoicing reference (TUL-5450); the field name matches the mobile app's request contract.
export const sendTranscriptEmail = async(chatRoomId, email, includeSummary, subject) => {
  try {
    const params = email ? `email=${encodeURIComponent(email)}` : null;
    const trimmedSubject = (subject || '').trim();
    const bodyParts = [
      ...(includeSummary ? ['includeSummary=true'] : []),
      ...(trimmedSubject ? [`subject=${encodeURIComponent(trimmedSubject)}`] : []),
    ];
    const body = bodyParts.length ? bodyParts.join('&') : null;
    return await requestService.post(
      `${endpoints.transcriptEmail}/${encodeURIComponent(chatRoomId)}`,
      params,
      body,
      { apiType: 'platform-v2' }
    );
  } catch (e) {
    console.error(e);
    throw e;
  }
};
